export const TIME_ZONE = 'Asia/Yekaterinburg';
export const DAILY_REWARDS = [10, 15, 20, 25, 30, 40, 50];
export const RED_NUMBERS = [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36];
export const WHEEL = [{ chance: 50, multiplier: 0 }, { chance: 30, multiplier: 1 }, { chance: 15, multiplier: 2 }, { chance: 4, multiplier: 5 }, { chance: 1, multiplier: 15 }];
export function cents(value) {
    if (!/^\d{1,12}(\.\d{1,2})?$/.test(value))
        throw new Error('Укажите сумму с точностью до сотой');
    const [whole, fraction = ''] = value.split('.');
    return BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
}
export function money(value) { const sign = value < 0n ? '-' : ''; const n = value < 0n ? -value : value; return `${sign}${n / 100n}.${String(n % 100n).padStart(2, '0')}`; }
export function dayKey(date) { return new Date(date.getTime() + 5 * 3600_000).toISOString().slice(0, 10); }
export function previousDay(day) { return new Date(Date.parse(day + 'T00:00:00Z') - 86400_000).toISOString().slice(0, 10); }
export function seasonKey(date) { return dayKey(date).slice(0, 7); }
export function seasonBounds(key) { const [y, m] = key.split('-').map(Number); return { start: new Date(Date.UTC(y, m - 1, 1) - 5 * 3600_000), end: new Date(Date.UTC(y, m, 1) - 5 * 3600_000) }; }
export function rouletteMultiplier(bet, n) {
    if (!Number.isInteger(n) || n < 0 || n > 36)
        throw new Error('Invalid roulette result');
    if (bet.type === 'number') {
        if (!Number.isInteger(bet.number) || bet.number < 0 || bet.number > 36)
            throw new Error('Выберите число 0–36');
        return bet.number === n ? 36 : 0;
    }
    if (n === 0)
        return 0;
    return (bet.type === 'red' ? RED_NUMBERS.includes(n) : bet.type === 'black' ? !RED_NUMBERS.includes(n) : bet.type === 'even' ? n % 2 === 0 : bet.type === 'odd' ? n % 2 === 1 : false) ? 2 : 0;
}
export function wheelMultiplier(draw) { if (!Number.isInteger(draw) || draw < 0 || draw >= 100)
    throw new Error('Invalid wheel draw'); let limit = 0; for (const s of WHEEL) {
    limit += s.chance;
    if (draw < limit)
        return s.multiplier;
} throw new Error('Unreachable'); }
export function towerPayout(stake, floors) { if (!Number.isInteger(floors) || floors < 0 || floors > 8)
    throw new Error('Invalid floor'); if (floors === 0)
    return stake; return stake * 95n * 4n ** BigInt(floors) / (100n * 3n ** BigInt(floors)); }
export function nextStreak(last, current, streak) { return last === previousDay(current) ? streak + 1 : 1; }
